module.exports = __webpack_public_path__ + "img/banner3.22f994c0.png";